import React from 'react';

const IDBadgeTab = () => {
    return (
        <div className="text-center py-16">
            <i className="fa fa-id-badge text-sky-400 text-6xl mb-4"></i>
            <h3 className='font-bold text-2xl'>Apply for LSB ID Card</h3>
            <p className=''>Track readiness and collection status of your official ID card.</p>
            <span className='text-sky-600 font-bold text-sm uppercase underline underline-offset-4'>Coming Soon</span>
        </div>
    );
};

export default IDBadgeTab;
